import React from 'react';
import { F1_GUIDES } from '../../../shared/f1-guides';

export function F1Discovery() {
  return <section aria-label="Explore F1 Tracker" className="mx-auto max-w-6xl px-5 py-10 border-t border-border">
    <div className="flex items-center justify-between gap-4 mb-5">
      <h2 className="text-lg font-semibold">Your next lap starts here</h2>
      <a href="/guides" className="text-sm text-primary underline underline-offset-4">All F1 guides</a>
    </div>
    <div className="grid gap-4 md:grid-cols-3">
      {F1_GUIDES.map((guide, i) => <a key={guide.slug} href={`/guides/${guide.slug}`} className="rounded-xl border border-border bg-card p-5 hover:border-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary transition-colors">
        <p className="text-xs uppercase tracking-widest text-primary mb-3">0{i + 1} / {guide.category}</p>
        <h3 className="font-semibold mb-2">{guide.title}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">{guide.description}</p>
      </a>)}
    </div>
    <p className="text-xs text-muted-foreground mt-6">Independent Formula 1 fan project. Free timing tools and data replays; no video broadcasts. Not affiliated with Formula 1 or the FIA.</p>
  </section>;
}

export function F1GuidePage({ slug }: { slug?: string }) {
  const guide = F1_GUIDES.find(item => item.slug === slug);
  return <div className="mx-auto max-w-6xl px-5 py-10">
    <nav aria-label="Breadcrumb" className="text-sm text-muted-foreground mb-8"><a href="/">Race centre</a> / <a href="/guides">F1 guides</a>{guide && <> / {guide.category}</>}</nav>
    <p className="text-xs uppercase tracking-widest text-primary mb-4">{guide?.category ?? 'The F1 Tracker field guide'}</p>
    <h1 className="text-3xl md:text-5xl font-bold tracking-tight max-w-3xl mb-5">{guide?.title ?? 'Follow the session. Understand the race.'}</h1>
    <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mb-8">{guide?.description ?? 'New to live timing or ready to look closer? Choose your way into Formula 1: follow a live session, revisit a data replay, or explore the strategy behind the lap times.'}</p>
    {guide && <>
      <a href={guide.href} className="inline-flex rounded-lg bg-primary text-primary-foreground px-5 py-3 font-semibold mb-10">{guide.action} →</a>
      <article className="max-w-3xl space-y-8 mb-12">{guide.sections.map(([heading, body]) => <section key={heading}><h2 className="text-xl font-semibold mb-3">{heading}</h2><p className="text-muted-foreground leading-7">{body}</p></section>)}</article>
    </>}
    <F1Discovery />
  </div>;
}
